import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { WrapperComponentDirective } from '@rd-lib/whitelabel/wrapper/wrapper.component';
import { AuthRenderState, LoyaltyCurrency, PointsSummary } from '@rd/types';

@Component({
  selector: 'rd-core-side-nav-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavWrapperComponent extends WrapperComponentDirective {
  @HostBinding('class.rd-core-side-nav-wrapper') componentClass = true;

  @Input() authRenderState: AuthRenderState;
  @Input() pointsSummary: PointsSummary;
  @Input() showSideNav: boolean;
  @Input() loyaltyCurrencySelected: LoyaltyCurrency;
  @Output() itemClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() logout: EventEmitter<void> = new EventEmitter<void>();

  componentName = 'core-side-nav';
}
